import { useCallback } from 'react';
import { gql } from 'apollo-boost';
import { useMutation } from 'shared/apollo';

export const updateServiceCollection = gql`
  mutation updateServiceCollection(
    $id: Int!
    $name: String!
    $description: String!
    $serviceIds: String!
    $donorIds: String
    $portfolioIds: String
  ) {
  updateCollection(
    id: $id
    name: $name
    description: $description
    serviceIds: $serviceIds
    donorIds: $donorIds
    portfolioIds: $portfolioIds
  ) {
      success
      id
    }
  }
`;

export function useUpdateServiceCollection() {
  const { data, isLoading, mutate } = useMutation();
  const run = useCallback((variables, onFinish) => {
    mutate(updateServiceCollection, variables, response => {
      if (typeof onFinish === 'function') {
        onFinish(response.updateCollection.id);
      }
    });
  }, []);
  return { data, isLoading, run };
}
